import React from "react";
import { Grid, Box, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import { Image } from "cloudinary-react";
import { ModernLiquidTable, LiquidIconButton } from "../../../../components/modern-table";
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import { getUrlsByUser } from "../../../../api/multilink";


export default function MultiLinkList(props) {
  const { id } = useSelector(({ auth }) => auth.user);
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      const data = await getUrlsByUser(id);
      if (data) {
        setRows(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      field: "_rowNumber",
      title: "No",
      width: 75,
      render: (rowData) => <p>{rowData._rowNumber}</p>,
    },
    {
      field: "icon",
      title: "Ikon",
      width: 75,
      render: (rowData) => (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Image cloudName="denr13kdi" publicId={rowData.icon} width={50} />
        </Box>
      ),
    },
    { field: "title", title: "Tajuk Program", width: 425 },
    {
      field: "url",
      title: "Pautan",
      render: (rowData) => (
        <a
          href={`https://sigmagema.com/links/${rowData.url}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#667eea', textDecoration: 'none' }}
        >
          {rowData.url}
        </a>
      ),
    },
    {
      field: "actions",
      title: "Tindakan",
      width: 100,
      render: (rowData) => (
        <Tooltip title="Edit">
          <Link to={`/app/multilink/edit?id=${rowData._id}`}>
            <LiquidIconButton size="small">
              <EditIcon />
            </LiquidIconButton>
          </Link>
        </Tooltip>
      ),
    },
  ];

  return (
    <Portlet>
      <PortletBody fluid={true}>
        <Grid className="p-3" container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                mb: 2,
                p: 2,
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
              }}
            >
              <span className="kt-section__sub">
                Senarai pautan multi-link yang telah dibuat
              </span>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <ModernLiquidTable
              columns={columns}
              data={rows}
              title={`Bilangan pautan: ${rows.length}`}
              loading={loading}
              onRefresh={fetchData}
              emptyStateMessage="Tiada pautan untuk dipaparkan"
              options={{
                selection: false,
                pageSize: 10,
                pageSizeOptions: [5, 10, 20, 50],
              }}
            />
          </Grid>
        </Grid>
      </PortletBody>
    </Portlet>
  );
}
